import { render, staticRenderFns } from "./CreateRuangan.vue?vue&type=template&id=ac2991c2"
import script from "./CreateRuangan.vue?vue&type=script&lang=js"
export * from "./CreateRuangan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports